<template>
  <div>
    <h1>Edit</h1>

    <b-row>
      <b-col>
        <SelectMunicipio v-model="address.city_id" />
      </b-col>
    </b-row>
    <pre>{{ address }}</pre>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SelectMunicipio from "../Components/SelectMunicipio.vue";

export default {
  data() {
    return {
      address: {
        city_id: "",
      },
    };
  },

  components: {
    SelectMunicipio,
  },

  computed: {
    ...mapState("municipios", ["municipio"]),
  },
  methods: {
    ...mapActions("municipios", ["ActionShow"]),
  },
  async created() {
    await this.ActionShow({ id: this.$route.params.id });
  },
};
</script>

<style></style>
